module.exports = __webpack_public_path__ + "img/prize-04-pic.a5ad7a50.png";